import { Button } from "components";
import { useState } from "react";
import { Minus, Plus } from "assets/icons";

export enum Operation {
  increment = "increment",
  decrement = "decrement",
}

interface CounterProps {
  defaultCount?: number;
  name?: string;
  min?: number;
  handleCountChange?: (operation: Operation, count: number) => void;
  label?: string;
}

export const CounterField = ({
  defaultCount = 0,
  handleCountChange,
  label,
  min,
}: CounterProps) => {
  const [count, setCount] = useState(defaultCount);

  const handleIncrement = () => {
    setCount((prev) => prev + 1);
    handleCountChange && handleCountChange(Operation.increment, count + 1);
  };

  const handleDecrement = () => {
    if (count === 0) return;
    if (min && count === min) return;
    setCount((prev) => prev - 1);
    handleCountChange && handleCountChange(Operation.decrement, count - 1);
  };

  return (
    <div className="flex w-full flex-col gap-2">
      {label && <span className="text-sm text-neutral-primary">{label}</span>}
      <div className="flex items-center justify-between gap-2 rounded-md bg-muted px-4 py-2">
        <span>{count}</span>
        <div className="flex gap-2">
          <Button
            onClick={handleIncrement}
            radius="full"
            isIconOnly
            className="bg-moss-primary p-0 text-white"
            aria-label="Increment"
          >
            <Plus />
          </Button>
          <Button
            disabled={count === 0}
            onClick={handleDecrement}
            radius="full"
            isIconOnly
            className="bg-white text-moss-primary"
            aria-label="Decrement"
          >
            <Minus />
          </Button>
        </div>
      </div>
    </div>
  );
};
